import { Component } from '@angular/core';

@Component({
  templateUrl: './konbini-confirmation.component.html',
  styleUrls: ['./konbini-confirmation.component.scss'],
})
export class KonbiniConfirmationComponent {
  // constructor() {}
}
